import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const useStyles = makeStyles(() => ({
  expandToggle: {
    width: 18,
    height: 18,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 10,
    color: COLORS.muted,
    cursor: 'pointer',
    flexShrink: 0,
    background: 'none',
    border: 'none',
    padding: 0,
  },
  nodeRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '5px 8px 5px 0',
    borderRadius: 4,
    marginBottom: 1,
    textAlign: 'left',
  },
  nodeRowSelected: {
    background: COLORS.primaryLight,
    borderLeft: `3px solid ${COLORS.primary}`,
  },
  nodeRowUnselected: {
    background: 'transparent',
    borderLeft: '3px solid transparent',
  },
  nodeIndent0: { paddingLeft: 8 },
  nodeIndent1: { paddingLeft: 15 },
  nodeIndent2: { paddingLeft: 22 },
  nodeIndent3: { paddingLeft: 29 },
  nodeIndent4: { paddingLeft: 36 },
  nodeIndent5: { paddingLeft: 43 },
  nodeIndent6: { paddingLeft: 50 },
  nodeIndent7: { paddingLeft: 57 },
  nodeIndent8: { paddingLeft: 64 },
  nodeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: 1,
    minWidth: 0,
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
    fontFamily: 'inherit',
    textAlign: 'left',
  },
  nodeIcon: {
    marginRight: 5,
    fontSize: 13,
    flexShrink: 0,
  },
  expandSpacer: {
    width: 18,
    flexShrink: 0,
  },
  checkbox: {
    marginRight: 6,
    flexShrink: 0,
    padding: 0,
    color: COLORS.primary,
    '&.Mui-checked': {
      color: COLORS.primary,
    },
  },
}));
